// Reusable ProcessContent Component
const ProcessContent = ({ stepId, activeTab, description, imageSrc }) => {
  return (
    <div
      id={stepId}
      className={`techstack_content ${activeTab === stepId ? "active" : ""}`}
    >
      <div className="tools-accordion-body">
        <div className="process-right-content">
          <div>
            <img src={imageSrc} alt="Custom Software Development Company" />
            <h6>{description.title}</h6>
            <p>{description.text}</p>
          </div>

          <div>
            <button
              data-toggle="modal"
              data-target="#myModal"
              className="fiu-need-left-btn mt-3 re-hero-btn"
            >
              <div className="re-btn-txt">Get Free Consultation</div>
              <span className="mx-2 right-arr">
                <i className="fa-solid fa-arrow-right"></i>
              </span>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProcessContent;
